import wootConstants from 'dashboard/constants/globals';
import {
  CHANNEL_FILTERS,
  channelBucketForInbox,
  inboxFilterId,
  inboxIdFromChannelFilter,
  matchesChannelFilter,
} from './channel';

export const getConversationTeamId = conversation =>
  conversation?.meta?.team?.id ? String(conversation.meta.team.id) : 'none';

export const matchesTeamFocus = (conversation, teamFilter) => {
  if (teamFilter === 'none') {
    return getConversationTeamId(conversation) === 'none';
  }

  return true;
};

export const filterConversationsByTeamFocus = (conversations, teamFilter) =>
  conversations.filter(conversation =>
    matchesTeamFocus(conversation, teamFilter)
  );

const inboxById = (inboxes, inboxId) =>
  inboxes.find(inbox => inbox.id === Number(inboxId)) || {};

export const filterConversationsByChannel = (
  conversations,
  inboxes,
  channelFilter
) =>
  conversations.filter(conversation =>
    matchesChannelFilter(
      inboxById(inboxes, conversation.inbox_id),
      channelFilter
    )
  );

export const countConversationsByChannel = (
  conversations,
  inboxes,
  channelFilters = CHANNEL_FILTERS
) =>
  channelFilters.reduce((acc, filter) => {
    acc[filter.id] =
      filter.id === 'all'
        ? conversations.length
        : filterConversationsByChannel(conversations, inboxes, filter.id)
            .length;

    return acc;
  }, {});

const numberOrNull = value => {
  const count = Number(value);
  return Number.isFinite(count) ? count : null;
};

export const buildChannelCountMap = ({
  inboxes,
  inboxCounts = {},
  allCount,
  channelFilters = CHANNEL_FILTERS,
}) => {
  const counts = {};
  const bucketTotals = {};
  const bucketCounts = {};
  const total = numberOrNull(allCount);

  if (total !== null) counts.all = total;

  inboxes.forEach(inbox => {
    const bucket = channelBucketForInbox(inbox);
    bucketTotals[bucket] = (bucketTotals[bucket] || 0) + 1;

    const inboxCount = numberOrNull(inboxCounts[inbox.id]);
    if (inboxCount === null) return;

    counts[inboxFilterId(inbox.id)] = inboxCount;
    const currentBucket = bucketCounts[bucket] || { count: 0, inboxes: 0 };
    bucketCounts[bucket] = {
      count: currentBucket.count + inboxCount,
      inboxes: currentBucket.inboxes + 1,
    };
  });

  channelFilters.forEach(filter => {
    if (filter.id === 'all') return;

    const bucketCount = bucketCounts[filter.id];
    if (bucketCount && bucketCount.inboxes === bucketTotals[filter.id]) {
      counts[filter.id] = bucketCount.count;
    }
  });

  return counts;
};

export const buildEssentialConversationFilters = ({
  teamFilter,
  status,
  page,
  channelFilter = 'all',
}) => {
  const isTeamId = /^\d+$/.test(String(teamFilter));
  const inboxId = inboxIdFromChannelFilter(channelFilter);
  const teamId = teamFilter === 'none' ? 'none' : undefined;

  return {
    inboxId,
    teamId: isTeamId ? String(teamFilter) : teamId,
    status,
    assigneeType:
      teamFilter === 'mine'
        ? wootConstants.ASSIGNEE_TYPE.ME
        : wootConstants.ASSIGNEE_TYPE.ALL,
    page,
    labels: [],
    sortBy: wootConstants.SORT_BY_TYPE.LAST_ACTIVITY_AT_DESC,
    essentialScope: true,
  };
};
